export const siteInfo = {
  brand: "天海翼影视内容站",
  brandShort: "天海翼",
  tagline: "影视作品与明星资讯大全",
  intro:
    "天海翼影视内容站聚焦天海翼的影视作品介绍、明星资料与最新资讯动态，收录其从影以来的代表作品与幕后故事，覆盖最新动态与经典作品。我们希望通过系统、清晰的内容整理，帮助影迷与影视爱好者更全面地了解她的作品脉络与创作历程。",
  email: "hello@tianhaiyi-films.example",
  location: "中国 · 上海",
  established: "2025",
};

export const heroSlides = [
  {
    id: "hero-1",
    title: "《雨停之后》定档 12 月",
    subtitle: "天海翼全新都市情感剧，一场关于重新靠近的温柔故事",
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20dramatic%20city%20skyline%20at%20dusk%2C%20deep%20blue%20tones%20with%20warm%20orange%20highlights%2C%20atmospheric%20cinematic%20mood%2C%20no%20text&width=1600&height=900&seq=thyi-hero-1&orientation=landscape",
    link: "/works/after-rain",
    tag: "最新定档",
  },
  {
    id: "hero-2",
    title: "《春山旧梦》经典重温",
    subtitle: "气质古装传奇，天海翼演绎乱世中的智慧与坚韧",
    image: "https://readdy.ai/api/search-image?query=moody%20cinematic%20landscape%20of%20misty%20mountains%20and%20river%2C%20deep%20blue%20and%20warm%20light%20contrast%2C%20atmospheric%20artistic%2C%20no%20text&width=1600&height=900&seq=thyi-hero-2&orientation=landscape",
    link: "/works/palace-of-spring",
    tag: "经典作品",
  },
  {
    id: "hero-3",
    title: "《春日来信》正在热播",
    subtitle: "一封迟到十年的信，让两位旧日同窗在春天重新相遇",
    image: "https://readdy.ai/api/search-image?query=elegant%20film%20premiere%20stage%20with%20warm%20spotlights%20and%20dark%20blue%20backdrop%2C%20glamorous%20cinematic%20atmosphere%2C%20no%20text&width=1600&height=900&seq=thyi-hero-3&orientation=landscape",
    link: "/works/spring-letter",
    tag: "热播推荐",
  },
];